import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  Search, 
  Notifications, 
  Person, 
  Settings, 
  Logout, 
  Help 
} from '@mui/icons-material';
import { logoutUser, getCurrentUser } from '../../utils/auth';

const Header = ({ title }) => {
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const currentUser = getCurrentUser();
  
  const toggleProfileMenu = () => {
    setShowProfileMenu(!showProfileMenu);
  };
  
  const handleLogout = () => {
    logoutUser();
  };
  
  return (
    <header className="bg-white border-b border-gray-200 h-16 flex items-center justify-between px-6 sticky top-0 z-20">
      <div>
        <h1 className="text-xl font-semibold text-gray-800">{title}</h1>
      </div>
      
      <div className="flex items-center space-x-4">
        <div className="relative">
          {/* <input
            type="text"
            placeholder="Rechercher..."
            className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          /> */}
          <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
            {/* <Search /> */}
          </div>
        </div>
        
        <button className="relative p-2 text-gray-600 hover:text-primary-600 hover:bg-gray-100 rounded-full transition-colors">
          {/* <Notifications /> */}
          <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
        </button>
        
        <div className="relative">
          <button 
            className="flex items-center space-x-2 focus:outline-none"
            onClick={toggleProfileMenu}
          >
            <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-semibold">
              {currentUser?.name?.charAt(0) || 'A'}
            </div>
            <span className="text-sm font-medium text-gray-700 hidden md:block">
              {currentUser?.name || 'Admin'}
            </span>
          </button>
          
          {showProfileMenu && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-200">
              <div className="px-4 py-2 border-b border-gray-100">
                <p className="text-sm font-medium text-gray-900">{currentUser?.name || 'Admin'}</p>
                <p className="text-xs text-gray-500">{currentUser?.email || 'admin@example.com'}</p>
              </div>
              
              {/* <Link 
                to="/profile" 
                className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                onClick={() => setShowProfileMenu(false)}
              >
                <Person className="w-4 h-4 mr-3 text-gray-500" />
                Mon profil
              </Link> */}
              
              {/* <Link 
                to="/settings" 
                className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                onClick={() => setShowProfileMenu(false)}
              >
                <Settings className="w-4 h-4 mr-3 text-gray-500" />
                Paramètres
              </Link> */}
              
              {/* <Link 
                to="/help" 
                className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                onClick={() => setShowProfileMenu(false)}
              >
                <Help className="w-4 h-4 mr-3 text-gray-500" />
                Aide
              </Link> */}
              
              <div className="border-t border-gray-100 mt-1"></div>
              
              <button 
                className="flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                onClick={handleLogout}
              >
                <Logout className="w-4 h-4 mr-3 text-gray-500" />
                Déconnexion
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
